// extracted by mini-css-extract-plugin
export var sliderRange = "_qp-2";
export var sliderRoot = "_qp-0";
export var sliderThumb = "_qp-3";
export var sliderTrack = "_qp-1";